import apiWorker from '../apiWorker'

const recent_activity = {

    update: (data) => apiWorker('post',   `/api/v1/core/recent_activity/update/`, data),

}

export default recent_activity;